/* eslint-disable react-hooks/exhaustive-deps */
import { Formik } from "formik";

import Spinner from "../../../../../components/Spinner/index";

import "./index.scss";
import useFormStore from "../store/useStore";
import { remask } from "../../../../../libs/remask-mask";
import Input from "../../../../../components/Input";
import useAuthData from "../../../../../hook/useAppData";
import { Iaddress } from "../../../model";
import { toastError } from "../../../../../components/Toast";
import { getCEP } from "../../../../../libs/getAddresByCep/getAddresByCep";
import { resCepApi } from "../../../../../libs/getAddresByCep/model";

function FormAddress() {
  const { token } = useAuthData();
  const { updateValue, setUpdateValueObj, setUpdateValues } = useFormStore();
  const { modo } = useFormStore();
  const { needSpinner } = useFormStore();
  const { saveOrSchedule, dateSchedule, handleSetDate } = useFormStore();

  async function setValuesOfCep(value: string) {
    const res: resCepApi = await getCEP(value, token);
    if (res?.type === "service_error") {
      setUpdateValues({ ...updateValue, ...updateValue.address });
      return toastError("CEP não encontrado");
    }
    const data: Iaddress = {
      ...updateValue?.address,
      zip_code: value,
      city: res.city,
      district: res.neighborhood,
      street: res.street,
      state: res.state,
    };
    setUpdateValues({
      ...updateValue,
      address: data,
    });
  }

  return (
    <Spinner status={needSpinner}>
      <div className="collaboratorContainer">
        <div className="title-form form-box-title">
          {modo === "create" ? (
            <h1 className="align-self-end">Adicionar endereço - {updateValue.name || "profissional"}</h1>
          ) : (
            <h1 className="align-self-end">Atualizar endereço - {updateValue.name || "profissional"}</h1>
          )}
          {saveOrSchedule == "schedule" && (
            <div className="schuduleContainer">
              <div className="calendar">
                <Input label="Data Agendamento" name="teste" placeholder="" value={dateSchedule} setValue={handleSetDate} type="date" />
              </div>
            </div>
          )}
        </div>

        <form className="form-container box-form title-form">
          <div className="row box-row">
            <Input
              className="form-input width-60vw"
              label="Logradouro"
              name="street"
              setValue={(e: any) => {
                setUpdateValueObj("address", e.target);
              }}
              value={updateValue.address.street}
              placeholder="Digite o nome da Rua"
              type="text"
              required={false}
              autofocus={true}
            />
            <Input
              className="form-input width-10-5vw"
              label="Numero"
              name="number"
              setValue={(e: any) => {
                setUpdateValueObj("address", e.target);
              }}
              value={updateValue.address.number}
              placeholder="Digite o número da casa"
              type="number"
              required={false}
              autofocus={false}
            />
          </div>
          <div className="row box-row">
            <Input
              className="form-input width-60vw"
              label="Complemento (Opcional)"
              name="complement"
              setValue={(e: any) => {
                setUpdateValueObj("address", e.target);
              }}
              value={updateValue.address.complement}
              placeholder="Informe o Complemento"
              type="text"
              required={false}
              autofocus={false}
            />
            <Input
              className="form-input width-60vw"
              label="Bairro"
              name="district"
              setValue={(e: any) => {
                setUpdateValueObj("address", e.target);
              }}
              value={updateValue.address.district}
              placeholder="Digite o nome do Bairro"
              type="text"
              required={false}
              autofocus={false}
            />
            <Input
              className="form-input width-10-5vw"
              label="CEP"
              name="zip_code"
              setValue={(e: any) => {
                setUpdateValueObj("address", e.target);
                if (e.target.value?.length === 10) setValuesOfCep(e.target.value);
              }}
              value={
                updateValue.address.zip_code && updateValue.address.zip_code !== ""
                  ? remask(updateValue.address.zip_code, ["99.999-999"])
                  : updateValue.address.zip_code
              }
              placeholder="Digite o CEP"
              type="text"
              maxLength={10}
              required={false}
              autofocus={false}
            />
          </div>
          <div className="row box-row">
            <Input
              className="form-input width-60vw"
              label="Cidade"
              name="city"
              setValue={(e: any) => {
                setUpdateValueObj("address", e.target);
              }}
              value={updateValue.address.city}
              placeholder="Digite o nome da Cidade"
              type="text"
              required={false}
              autofocus={false}
            />
            <Input
              className="form-input width-10-5vw"
              label="Estado"
              name="state"
              setValue={(e: any) => {
                setUpdateValueObj("address", e.target);
              }}
              value={
                updateValue.address.state && updateValue.address.state !== ""
                  ? remask(updateValue.address.state.toUpperCase(), ["AA"])
                  : updateValue.address.state
              }
              placeholder="Sigla do estado"
              type="text"
              maxLength={2}
              required={false}
              autofocus={false}
            />
            <Input
              className="form-input width-10-5vw"
              label="País"
              name="country"
              setValue={(e: any) => {
                setUpdateValueObj("address", e.target);
              }}
              value={updateValue.address.country}
              placeholder="Ex: França"
              type="text"
              maxLength={20}
              required={false}
              autofocus={false}
            />
          </div>
        </form>
      </div>
    </Spinner>
  );
}

export default FormAddress;
